import { FileSystemHandle } from "browser-fs-access";
import { atom } from "../atom";

export const recentFilesAtom = atom<FileSystemHandle[] | undefined>(undefined);
